module.exports = __webpack_public_path__ + "img/image21.7cfcc179.png";